function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 3.231,
  width: 20,
  height: 7.385,
  rx: 3.692
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 12.461,
  width: 20,
  height: 7.385,
  rx: 3.692
});

function SvgVendorMenuOrders(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjMiIHZpZXdCb3g9IjAgMCAyNCAyMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMiIgeT0iMy4yMzA3NyIgd2lkdGg9IjIwIiBoZWlnaHQ9IjcuMzg0NjIiIHJ4PSIzLjY5MjMxIiAvPgo8cmVjdCB4PSIyIiB5PSIxMi40NjE1IiB3aWR0aD0iMjAiIGhlaWdodD0iNy4zODQ2MSIgcng9IjMuNjkyMzEiIC8+Cjwvc3ZnPgo=";
export { SvgVendorMenuOrders as ReactComponent };